
export class ScheduleLoads {
	scheduleId: number = 0;
	loads: number = 0;
	startDate: string = '';
	dayNumber: number = 0;
	actualLoads: number = 0;
}
 